import {FormInputProps} from "_types/form";
import {Form, InputGroup} from 'react-bootstrap';
import {useState} from "react";
import classNames from "classnames";
import {get} from "react-hook-form";
import {When} from "react-if";

export const PasswordInput = ({
    name,
    placeholder,
    refCallback,
    errors,
    control,
    register,
    hasEye = true,
    className,
    ...otherProps
}: FormInputProps) => {
    const fieldErrors = get(errors, name);
    const [showPassword, setShowPassword] = useState<boolean>(false);

    return (
        <>
            <InputGroup className="mb-0">
                <Form.Control
                    type={showPassword ? 'text' : 'password'}
                    placeholder={placeholder}
                    name={name}
                    id={name}
                    as="input"
                    ref={(r: HTMLInputElement) => {
                        if (refCallback) refCallback(r);
                    }}
                    className={className}
                    isInvalid={fieldErrors}
                    {...(register ? register(name) : {})}
                    autoComplete={name}
                    {...otherProps}
                />
                <When condition={hasEye}>
                    <div
                        className={classNames('cursor-pointer', 'input-group-text', 'input-group-password', {
                            'show-password': showPassword,
                        })}
                        data-password={showPassword ? 'true' : 'false'}
                    >
                    <span
                        className="password-eye"
                        onClick={() => {
                            setShowPassword(!showPassword);
                        }}
                    ></span>
                    </div>
                </When>
            </InputGroup>

            {fieldErrors ? (
                <Form.Control.Feedback type="invalid" className="d-block">
                    {fieldErrors['message'] as any}
                </Form.Control.Feedback>
            ) : null}
        </>
    );
};
